var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { AddJoinCommonRequirementsWizardUIManager } from "../../AddJoinCommonRequirementsWizardUIManager";
const _informedConsentTranslationsWizardSteps = [
    "LANGUAGE_SELECTION",
    "IMPORT_METHOD",
    "IMPORT_METHOD_AI_GENERATION",
    "IMPORT_METHOD_AI_REGENERATION",
    "IMPORT_METHOD_DOCUMENT_TRANSLATIONS",
    "IMPORT_METHOD_DOCUMENT_TRANSLATIONS_GENERATING",
];
export const informedConsentTranslationsWizardStepValues = _informedConsentTranslationsWizardSteps;
export class InformedConsentTranslationsWizardUIManager extends AddJoinCommonRequirementsWizardUIManager {
    constructor() {
        super(...arguments);
        this.importTranslationDialogVisible = false;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], InformedConsentTranslationsWizardUIManager.prototype, "importTranslationDialogVisible", void 0);
